const yesNoConductFinancialTransactionsWithoutAdvisor = {
    yes: 'Oui',
    no: 'Non',
};

export default yesNoConductFinancialTransactionsWithoutAdvisor;
